function isURLValid(url) {
  if (typeof url !== 'string') return false;
  try {
    const test = new URL(url);
    return test.href;
  } catch (_unused) {
    return false;
  }
}
export default isURLValid;
//# sourceMappingURL=isURLValid.js.map